//styles
import * as S from './DinningModalUI.styles';

const DinningModalUI = ({data = [], header = '', sliderComponent = null, isMweb = false}) => {
  return (
    <S.InclusiveWrapper isMweb={isMweb}>
      {header ? (
        <S.BkIncModalHeader>
          <h3>{header}</h3>
        </S.BkIncModalHeader>
      ) : null}

      <S.BkIncModalContent className="bkIncModalContent">
        <S.BkIncModalBody isMweb={isMweb}>
          {data?.map((data, index) => (
            <div className="dinning-section" id={`inclusive-${index + 1}`}>
              <h4 className="font18 latoBlack blackText appendBottom15">{data?.description}</h4>
              {sliderComponent(data?.images)}
              {/* {data?.images?.[0]?.length ? (
                <img src={data?.images?.[0]} className="bkIncModal__img" />
              ) : null} */}
              <S.BkIncModalList marginBtm={isMweb ? '0px' : ''} isMweb={isMweb}>
                {data?.rules?.map(point => (
                  <li className="bkIncModal__list--item">
                    <span>{point?.text}</span>
                  </li>
                ))}
              </S.BkIncModalList>
            </div>
          ))}
        </S.BkIncModalBody>
      </S.BkIncModalContent>
    </S.InclusiveWrapper>
  );
};

export default DinningModalUI;
